export const YM_COUNTER_FOR_YM_UID = 45300591;

export const YM_COUNTER_CLIENT_ID = 'YM_COUNTER_CLIENT_ID';
export const ROISTAT_VISIT_ID = 'ROISTAT_VISIT_ID';

export const PROD_COM_HOST_NAME = 'app.zvuk-b2b.com';
export const PROD_BY_HOST_NAME = 'app.zvuk-b2b.by';
export const DEV_HOST_NAME = 'smartlk-dev-1.zvuk-b2b.com';

export const YM_ID_TEST = 106500279;
export const YM_ID_COM = 89756199;
export const YM_ID_BY = 103837247;
